export const Steps = [
    {
        id: 1,
        label: "Identificação",
        step: true,
        completed: false,
    },
    {
        id: 2,
        label: "Vistoria",
        step: false,
        completed: false,
    },
]

export const OptionsSelectDataVisit = [
    {
        id: 1,
        label: "Manhã",
        value: "Manhã",
    },
    {
        id: 2,
        label: "Tarde",
        value: "Tarde",
    },
    {
        id: 3,
        label: "Noite",
        value: "Noite",
    },
]